import { render, staticRenderFns } from "./CoursePpt.vue?vue&type=template&id=0ac87640&scoped=true&"
import script from "./CoursePpt.vue?vue&type=script&lang=js&"
export * from "./CoursePpt.vue?vue&type=script&lang=js&"
import style0 from "./CoursePpt.vue?vue&type=style&index=0&id=0ac87640&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0ac87640",
  null
  
)

component.options.__file = "CoursePpt.vue"
export default component.exports